
































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IClient } from "@/models/clients";
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "invoices-listing": () =>
      import("@/components/app/global/invoices/invoicesListing.vue")
  }
})
export default class CalculatePrevCommissionsModal extends Vue {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  // Variables
  public isProcessing = false;
  public selectedInvoiceIds: IInvoice["id"][] = [];

  // Methods

  public selectInvoice(invoice: IInvoice) {
    if (!_.isEmpty(_.get(invoice, "affiliate_commissions", []))) return;

    if (this.selectedInvoiceIds.includes(invoice.id)) {
      this.selectedInvoiceIds = _.filter(
        this.selectedInvoiceIds,
        selectedInvoiceId => selectedInvoiceId !== invoice.id
      );
    } else {
      this.selectedInvoiceIds.push(invoice.id);
    }
  }

  public updateSelectedIds(selectedInvoiceIds: IInvoice["id"][]) {
    this.selectedInvoiceIds = selectedInvoiceIds;
  }

  public async calculatePrevCommissions() {
    try {
      this.isProcessing = true;

      await this.$store.dispatch(
        `data/${DataModules.AFFILIATES_REFERRALS}/calculatePrevCommissions`,
        { clientId: this.clientId, invoiceIds: this.selectedInvoiceIds }
      );

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.commissions_successfully_allocated")
      });

      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }
}
